(function() {
    angular
        .module('emarket.main.post')
        .controller('PostPanelDetailController', ['$log', '$state', '$controller', '$scope', '$timeout', '$rootScope', '$window', '$location', 'Utils', 'Post', 'mdPanelRef', 'post', 'selected', function($log,
            $state,
            $controller,
            $scope,
            $timeout,
            $rootScope,
            $window,
            $location,
            Utils,
            Post,
            mdPanelRef,
            post,
            selected) {
            var changeState = false;
            var currentUrl = $location.absUrl();
            var vm = this;
            var model = Post;
            angular.extend(vm,
                $controller('PostDetailController', {
                    $scope: $scope,
                    post: post
                }));
            var replaceUrl = function(id) {
                currentUrl = currentUrl.replace(/detalle\/.+/, 'detalle/' + id);
                changeState = false;
                $state.transitionTo('main.post.search.detail',
                    {
                        title: id
                    },
                    {
                        location: 'replace', // This makes it update URL
                        inherit: true,
                        relative: $state.$current,
                        notify: false // This makes it not reload
                    });
            };
            $window.onpopstate = function(event) {
                var toUrl = event.target.location.href;
                if (toUrl === currentUrl && changeState) {
                    $window.history.back();
                }
            };
            $rootScope.$on('$stateChangeSuccess', function() {
                $log.info('changing');
            });
            $rootScope.$on('$locationChangeSuccess', function(event, toUrl, fromUrl) {
                if (/contactar=1/.test(fromUrl)) {
                    $timeout(function() {
                        changeState = true;
                    }, 500);
                } else {
                    changeState = false;
                }
            });
            var scrollToTop = function() {
                Utils.scrollTo('top', '.post-detail__panel md-content');
            };
            vm.relatedPromise.then(function(posts) {
                vm.relatedProducts = posts;
            });
            vm.disableNext =
        selected.index + 1 === selected.posts.length ? true : false;
            vm.disablePrev = selected.index === 0 ? true : false;
            vm.close = function() {
                mdPanelRef.close();
            };
            vm.next = function() {
                if (selected.index + 1 < selected.posts.length) {
                    selected.index += 1;
                    vm.post = selected.posts[selected.index];
                    model
                        .$find(selected.posts[selected.index]._id)
                        .$asPromise()
                        .then(function(post) {
                            vm.post = post;
                        });
                    if (selected.index + 1 === selected.posts.length) {
                        vm.disableNext = true;
                    }
                    replaceUrl(vm.post._id);
                    vm.disablePrev = false;
                    scrollToTop();
                }
            };
            vm.prev = function() {
                if (selected.index > 0) {
                    selected.index -= 1;
                    vm.post = selected.posts[selected.index];
                    model
                        .$find(selected.posts[selected.index]._id)
                        .$asPromise()
                        .then(function(post) {
                            vm.post = post;
                        });
                    if (selected.index === 0) {
                        vm.disablePrev = true;
                    }
                    vm.disableNext = false;
                    replaceUrl(vm.post._id);
                    scrollToTop();
                }
            };
            vm.selectedPost = post;
        }]);
}());
